import { styles, variants, TooltipContentTheme } from '../TooltipContentStyles.css';
import { baseTheme } from './TooltipContentBaseTheme.css';
import { multiVariantStyles } from './TooltipContentVariants.css';

/*******************
 * Component Theme
 *******************/

const TooltipContentStableTheme: TooltipContentTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { TooltipContentStableTheme };
